// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider_4a8ad3f1 {
  height: 1.334rem;
  margin-left: 0.667rem;
  border-left: 0.084rem solid #84919b;
}
.dropdown-compound-secondary-button_4a8ad3f1 {
  width: 2.5rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `divider_4a8ad3f1`,
	"dropdown-compound-secondary-button": `dropdown-compound-secondary-button_4a8ad3f1`
};
export default ___CSS_LOADER_EXPORT___;
